import React from "react";
import * as S from "./styles";
import { useTranslation } from "hooks";
import { translations } from "./translations";

interface IGridProps {
  taxas: Record<string, any>[];
}

const Item: React.FC<{ taxa: Record<string, any> }> = ({ taxa }) => {
  const { getTranslation } = useTranslation(translations);
  const isActive = !taxa.deleted_at;

  const formatDate = (dateString: string) => {
    if (!dateString) return "--";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  };

  return (
    <S.ItemContainer>
      <S.ItemContent>
        <S.ItemValue>{taxa.porcentage_rate ? `${taxa.porcentage_rate}%` : "--"}</S.ItemValue>
        <S.ItemValue>{taxa.user?.name || "--"}</S.ItemValue>
        <S.ItemValue>{formatDate(taxa.created_at)}</S.ItemValue>
        <S.ItemValue>{formatDate(taxa.deleted_at)}</S.ItemValue>
        <S.StatusBadge isActive={isActive}>
          {isActive ? getTranslation("ativo") : getTranslation("inativo")}
        </S.StatusBadge>
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridValePedagioTaxas: React.FC<IGridProps> = ({ taxas = [] }) => {
  const { getTranslation } = useTranslation(translations);

  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation("taxa")}</S.Label>
        <S.Label>{getTranslation("usuario")}</S.Label>
        <S.Label>{getTranslation("criadoEm")}</S.Label>
        <S.Label>{getTranslation("deletadoEm")}</S.Label>
        <S.Label>{getTranslation("status")}</S.Label>
      </S.Header>
      {taxas.length > 0 &&
        taxas.map((taxa) => <Item taxa={taxa} key={taxa.id} />)}
    </S.Container>
  );
};